<div class="request__step mt-4" style="margin-bottom: 0;">
    <h3 class="txt txt--section">2. Información de contrato</h3>
    <small class="txt txt--paragraph">Puedes actualizar el contrato asociado a esta licencia.</small>
    <div class="row mt-3 pb-3">
        <div class="col-12 col-md-6 col-lg-4 mt-3">
            <app-select
            title="Contrato"
            textInformation="Selecciona el nuevo contrato asociado a la licencia."
            [optionalTooltip]="showTooltip"
            textTooltip="helo"
            [options]="options"
            [controlForm]="controlForm"
            ></app-select>
        </div>
    </div>

</div>
